import React, { FC, ReactNode } from 'react'
import classNames from 'classnames'

import styles from './Button.module.scss'
import { ButtonSize, ButtonType } from '../../../types/Button'

interface Props {
  type: ButtonType
  actionType?: string
  children?: ReactNode
  pending?: boolean
  disabled?: boolean
  stretch?: boolean
  toggled?: boolean
  onClick?: () => void
  size?: ButtonSize
  id?: string
}

export const Button: FC<Props> = ({
  actionType = 'button',
  size = 'regular',
  type = 'primary',
  toggled = false,
  pending = false,
  disabled = false,
  stretch = false,
  onClick,
  children,
  ...props
}) => {
  const classList = classNames(styles.baseButton, {
    [styles.pending]: pending,
    [styles.disabled]: disabled,
    [styles.toggleButtonToggled]: toggled,

    [styles.buttonBig]: size === 'big',
    [styles.buttonRegular]: size === 'regular',
    [styles.buttonSmall]: size === 'small',
    [styles.buttonStretch]: stretch,

    [styles.primaryButton]: type === 'primary',
    [styles.primaryInvertedButton]: type === 'primary-inverted',
    [styles.primaryInvertedBlackButton]: type === 'primary-inverted-black',
    [styles.secondaryButton]: type === 'secondary',
    [styles.secondaryInvertedButton]: type === 'secondary-inverted',
    [styles.tertiaryButton]: type === 'tertiary',
    [styles.loadMoreButton]: type === 'load-more',
    [styles.contextMenuButton]: type === 'context-menu',
    [styles.contextMenuButtonInverted]: type === 'context-menu-inverted',
    [styles.toggleButton]: type === 'toggle',
  })
  const isContextMenu = type === 'context-menu' || type === 'context-menu-inverted'

  return (
    // @ts-ignore ignore button type to preserve old functionality work as it is
    <button className={classList} disabled={disabled} onClick={onClick} type={actionType} {...props}>
      {pending && (
        <div className={styles.baseButtonSpinner}>
          <svg width="19" height="19" viewBox="0 0 19 19">
            <clipPath id="spinnerClipPath">
              <path d="M.5 9.5a1.5 1.5 0 0 1 3 0 6 6 0 1 0 6-6 1.5 1.5 0 0 1 0-3 9 9 0 1 1-9 9z" />
            </clipPath>
          </svg>
        </div>
      )}

      {!pending && isContextMenu && (
        <div className={styles.baseButtonDotsContainer}>
          <div className={styles.baseButtonDot} />
          <div className={styles.baseButtonDot} />
          <div className={styles.baseButtonDot} />
        </div>
      )}

      {!pending && !isContextMenu && children}
    </button>
  )
}
